const formatTime = time => {
  let year = time.getFullYear();
  let month = time.getMonth() + 1 < 10 ? "0" + (time.getMonth() + 1) : time.getMonth() + 1;
  let date = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();

  let hours = time.getHours() < 10 ? "0" + time.getHours() : time.getHours();
  let minutes = time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes();
  let seconds = time.getSeconds() < 10 ? "0" + time.getSeconds() : time.getSeconds();

  let str = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
  if (str.includes("NaN")) return "";
  return str;
};

const localTime = (zone, time) => {
  if (zone && zone !== "null") {
    try {
      // 参数zone为时区值数字，比如北京为东八区则输入+8,西5输入-5
      // 参数time为要转换的时间(Date类型)
      if (typeof zone !== "number") zone = Number(zone);
      if (typeof time === "string") time = new Date(time);
      let len = time.getTime();
      // 本地时间与GMT时间的时间偏移差
      // let offset = time.getTimezoneOffset() * 60000;
      // 得到现在的格林尼治时间
      let utcTime = len - 8 * 3600000;
      let zoneTime = new Date(utcTime + 3600000 * zone);
      return formatTime(zoneTime);
    } catch (e) {
      return time;
    }
  }
  return time;
};

// 12小时制展示（月/日/年 时:分:秒 AM/PM），用于首页最近交易等展示场景
const formatTo12Hour = dateStr => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr;
  let hours = date.getHours();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  const mins = String(date.getMinutes()).padStart(2, "0");
  const secs = String(date.getSeconds()).padStart(2, "0");
  return `${month}/${day}/${year} ${hours}:${mins}:${secs} ${ampm}`;
};

export default {
  formatTime,
  localTime,
  formatTo12Hour
};
